import type { RouteObject } from "react-router-dom";
import { AppointmentsPage } from "./AppointmentsPage";
import { FollowupsPage } from "./FollowupsPage";
import { TasksPage } from "./TasksPage";

/** The three work lists. Home's cards link to each. */
export const routes: RouteObject[] = [
  { path: "followups", element: <FollowupsPage /> },
  { path: "followups/appointments", element: <AppointmentsPage /> },
  { path: "followups/tasks", element: <TasksPage /> },
];
